// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"d03eed8a","704":"5e1e1dec"}[chunkId] + ".chunk.css";
};